export default {
  routerList: [
    //========财务管理========
    {
      path: "/FM/receivableWriteOff",
      name: "receivableWriteOff",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/receivableWriteOff",
        ], (comp) => resolve({ ...comp.default, name: "receivableWriteOff" })),
      meta: {
        title: "应收核销总表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ClearingBill/:id",
      name: "ClearingBill",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/ClearingBill",
        ], (comp) => resolve({ ...comp.default, name: "ClearingBill" })),
      meta: {
        title: "生成对账单",
        keepAlive: true,
      },
    },
    {
      path: "/FM/OpenInvoice",
      name: "OpenInvoice",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/OpenInvoice"], (
          comp
        ) => resolve({ ...comp.default, name: "OpenInvoice" })),
      meta: {
        title: "新建开票",
        keepAlive: true,
      },
    },
    {
      path: "/FM/PayableDetails",
      name: "PayableDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/PayableDetails",
        ], (comp) => resolve({ ...comp.default, name: "PayableDetails" })),
      meta: {
        title: "新建开票",
        keepAlive: true,
      },
    },
    {
      path: "/FM/OrderDetails/",
      name: "OrderDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/OrderDetails",
        ], (comp) => resolve({ ...comp.default, name: "OrderDetails" })),
      meta: {
        title: "明细",
        keepAlive: true,
      },
    },

    {
      path: "/FM/PayableWriteoff",
      name: "PayableWriteoff",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/PayableWriteoff",
        ], (comp) => resolve({ ...comp.default, name: "PayableWriteoff" })),
      meta: {
        title: "应付核销总表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/WaybillReceivable",
      name: "WaybillReceivable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/WaybillReceivable",
        ], (comp) => resolve({ ...comp.default, name: "WaybillReceivable" })),
      meta: {
        title: "运单应收核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/UOF",
      name: "UOF",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/Abnormal"], (
          comp
        ) => resolve({ ...comp.default, name: "UOF" })),
      meta: {
        title: "异常单核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/Outbound",
      name: "Outbound",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/Outbound"], (
          comp
        ) => resolve({ ...comp.default, name: "Outbound" })),
      meta: {
        title: "外发单核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/Depart",
      name: "Depart",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/Depart"], (
          comp
        ) => resolve({ ...comp.default, name: "Depart" })),
      meta: {
        title: "发车单核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/FW/OtherIncome",
      name: "FWOtherIncome",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/OtherIncome"], (
          comp
        ) => resolve({ ...comp.default, name: "FWOtherIncome" })),
      meta: {
        title: "其他收入核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/FW/OtherExpenses",
      name: "FWOtherExpenses",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/OtherExpenses",
        ], (comp) => resolve({ ...comp.default, name: "FWOtherExpenses" })),
      meta: {
        title: "其他支出核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/VehicleCost",
      name: "VehicleCost",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/VehicleCost"], (
          comp
        ) => resolve({ ...comp.default, name: "VehicleCost" })),
      meta: {
        title: "车辆成本核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/BillWriteoff",
      name: "BillWriteoff",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/BillWriteoff",
        ], (comp) => resolve({ ...comp.default, name: "BillWriteoff" })),
      meta: {
        title: "对账单核销",
        keepAlive: true,
      },
    },
    {
      path: "/FM/BillWriteoff/detailList",
      name: "BillWriteoffDetailList",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/excel/BillWriteoff",
        ], (comp) => resolve({ ...comp.default, name: "BillWriteoff" })),
      meta: {
        title: "导出明细",
        keepAlive: true,
      },
      props ({ query: { statementIds } }) {
        return { statementIds };
      },
    },
    {
      path: "/FM/OrderReceivable",
      name: "OrderReceivable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/OrderReceivable",
        ], (comp) => resolve({ ...comp.default, name: "OrderReceivable" })),
      meta: {
        title: "订单应收",
        keepAlive: true,
      },
    },
    {
      path: "/FM/OrderPayable",
      name: "OrderPayable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/OrderPayable",
        ], (comp) => resolve({ ...comp.default, name: "OrderPayable" })),
      meta: {
        title: "订单应付",
        keepAlive: true,
      },
    },
    {
      path: "/FM/CollectLoans",
      name: "CollectLoans",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/CollectLoans",
        ], (comp) => resolve({ ...comp.default, name: "CollectLoans" })),
      meta: {
        title: "代收货款",
        keepAlive: true,
      },
    },
    {
      path: "/FM/agent/revoke",
      name: "CollectLoansRovoke",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/agent/revoke",
        ], (comp) => resolve({ ...comp.default, name: "CollectLoansRovoke" })),
      meta: {
        title: "代收货款收回",
        keepAlive: true,
      },
    },
    {
      path: "/FM/agent/pay",
      name: "CollectLoansPay",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FinancialWriteOff/agent/pay"], (
          comp
        ) => resolve({ ...comp.default, name: "CollectLoansPay" })),
      meta: {
        title: "代收货款支付",
        keepAlive: true,
      },
    },
    {
      path: "/FM/MtExpenditure",
      name: "MtExpenditure",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ManageQuotes/MtExpenditure"], (
          comp
        ) => resolve({ ...comp.default, name: "MtExpenditure" })),
      meta: {
        title: "费项类型维护",
        keepAlive: true,
      },
    },
    {
      path: "/FM/SetExpenditure",
      name: "SetExpenditure",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ManageQuotes/SetExpenditure"], (
          comp
        ) => resolve({ ...comp.default, name: "SetExpenditure" })),
      meta: {
        title: "费项设置",
        keepAlive: true,
      },
    },
    // 报表
    {
      path: "/FM/CustomPL",
      name: "CustomPL",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/CustomPL"], (comp) =>
          resolve({ ...comp.default, name: "CustomPL" })),
      meta: {
        title: "客户损益表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/TransportPL",
      name: "TransportPL",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/TransportPL"], (
          comp
        ) => resolve({ ...comp.default, name: "TransportPL" })),
      meta: {
        title: "运单损益表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/VehiclePL",
      name: "VehiclePL",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/VehiclePL"], (comp) =>
          resolve({ ...comp.default, name: "VehiclePL" })),
      meta: {
        title: "车辆损益表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/DepartPL",
      name: "DepartPL",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/DepartPL"], (comp) =>
          resolve({ ...comp.default, name: "DepartPL" })),
      meta: {
        title: "部门损益表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/DriverEscort",
      name: "DriverEscort",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/DriverEscort"], (
          comp
        ) => resolve({ ...comp.default, name: "DriverEscort" })),
      meta: {
        title: "司机押运费用统计",
        keepAlive: true,
      },
    },
    {
      path: "/FM/StevedoreCost",
      name: "StevedoreCost",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/StevedoreCost"], (
          comp
        ) => resolve({ ...comp.default, name: "StevedoreCost" })),
      meta: {
        title: "装卸员装卸费用清单",
        keepAlive: true,
      },
    },
    {
      path: "/FM/TransportFare",
      name: "TransportFare",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/TransportFare"], (
          comp
        ) => resolve({ ...comp.default, name: "TransportFare" })),
      meta: {
        title: "运单车费分摊清单",
        keepAlive: true,
      },
    },
    {
      path: "/FM/BillsDetailed",
      name: "BillsDetailed",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/BillsDetailed"], (
          comp
        ) => resolve({ ...comp.default, name: "BillsDetailed" })),
      meta: {
        title: "应收账款明细",
        keepAlive: true,
      },
    },
    {
      path: "/FM/OutboundDetailed",
      name: "OutboundDetailed",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/OutboundDetailed"], (
          comp
        ) => resolve({ ...comp.default, name: "OutboundDetailed" })),
      meta: {
        title: "外发应付账款明细",
        keepAlive: true,
      },
    },
    {
      path: "/FM/InviteDetailed",
      name: "InviteDetailed",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/InviteDetailed"], (
          comp
        ) => resolve({ ...comp.default, name: "InviteDetailed" })),
      meta: {
        title: "外请应付账款明细",
        keepAlive: true,
      },
    },
    {
      path: "/FM/VehicleStowage",
      name: "VehicleStowage",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportForms/VehicleStowage"], (
          comp
        ) => resolve({ ...comp.default, name: "VehicleStowage" })),
      meta: {
        title: "车辆配载",
        keepAlive: true,
      },
    },
    // 资金管理
    {
      path: "/FM/FundAccountNo",
      name: "FundAccountNo",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FAMS/FundAccountNo"], (comp) =>
          resolve({ ...comp.default, name: "FundAccountNo" })),
      meta: {
        title: "资金账号",
        keepAlive: true,
      },
    },
    {
      path: "/FM/FundAllocation",
      name: "FundAllocation",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FAMS/FundAllocation"], (comp) =>
          resolve({ ...comp.default, name: "FundAllocation" })),
      meta: {
        title: "资金调拨",
        keepAlive: true,
      },
    },
    {
      path: "/FM/CapitalDaybook",
      name: "CapitalDaybook",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FAMS/CapitalDaybook"], (comp) =>
          resolve({ ...comp.default, name: "CapitalDaybook" })),
      meta: {
        title: "资金流水账",
        keepAlive: true,
      },
    },
    // 其他收入
    {
      path: "/FM/OtherIncome",
      name: "OtherIncome",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/OtherIncome"], (comp) =>
          resolve({ ...comp.default, name: "OtherIncome" })),
      meta: {
        title: "其他收入",
        keepAlive: true,
      },
    },
    {
      path: "/FM/NewOtherIncome/:id",
      name: "NewOtherIncome",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/OtherIncomeMOD/NewOtherIncome"], (
          comp
        ) => resolve({ ...comp.default, name: "NewOtherIncome" })),
      meta: {
        title: "新建其他收入",
        keepAlive: true,
      },
    },
    // 其他支出
    {
      path: "/FM/OtherExpenses",
      name: "OtherExpenses",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/OtherExpenses"], (comp) =>
          resolve({ ...comp.default, name: "OtherExpenses" })),
      meta: {
        title: "其他支出",
        keepAlive: true,
      },
    },
    {
      path: "/FM/NewOtherExpenses/:id",
      name: "NewOtherExpenses",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/OtherExpensesMOD/NewOtherExpenses",
        ], (comp) => resolve({ ...comp.default, name: "NewOtherExpenses" })),
      meta: {
        title: "新建其他支出",
        keepAlive: true,
      },
    },
    // 应收应付审核总表
    {
      path: "/FM/ARAPSummary",
      name: "ARAPSummary",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ARAPSummary"], (comp) =>
          resolve({ ...comp.default, name: "ARAPSummary" })),
      meta: {
        title: "应收应付审核总表",
        keepAlive: true,
      },
    },
    // 发票管理
    {
      path: "/FM/InvoicesControl",
      name: "ARAPInvoicesControlSummary",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/InvoicesControl"], (comp) =>
          resolve({ ...comp.default, name: "InvoicesControl" })),
      meta: {
        title: "发票管理",
        keepAlive: true,
      },
    },
    {
      path: "/FM/InvoicesAdd/:id",
      name: "InvoicesAdd",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/InvoicesControlMOD/InvoicesAddRX",
        ], (comp) => resolve({ ...comp.default, name: "InvoicesAdd" })),
      meta: {
        title: "开票",
        keepAlive: true,
      },
    },
    //  客商管理
    // -----合世
    // {
    //     path: "/Customers/NVOCC",
    //     name:'aaa',component: (resolve) => require(["@/pages/Customers/NVOCC"],comp => resolve({...comp.default,name:'aaa'})),
    //     meta: {
    //         title: "承运商档案",
    //         keepAlive: true,
    //     },
    // },
    // {
    //     path: "/Customers/NVOCCMOD/Create",
    //     name:'aaa',component: (resolve) => require(["@/pages/Customers/NVOCCMOD/Create"],comp => resolve({...comp.default,name:'aaa'})),
    //     meta: {
    //         title: "新建承运商档案",
    //         keepAlive: true,
    //     },
    // },
    // {
    //     path: "/Customers/NVOCCMOD/Edit",
    //     name:'aaa',component: (resolve) => require(["@/pages/Customers/NVOCCMOD/ModifyPage"],comp => resolve({...comp.default,name:'aaa'})),
    //     meta: {
    //         title: "修改承运商档案",
    //         keepAlive: true,
    //     },
    // },
    // -----合世
    {
      path: "/Customers/NVOCC",
      name: "NVOCC",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCRX"], (comp) =>
          resolve({ ...comp.default, name: "NVOCC" })),
      meta: {
        title: "承运商档案",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/NVOCCMOD/Create",
      name: "NVOCCC",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCMODRX/Create"], (comp) =>
          resolve({ ...comp.default, name: "NVOCCV" })),
      meta: {
        title: "新建承运商档案",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/NVOCCMOD/Edit",
      name: "NVOCCE",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCMODRX/ModifyPage"], (comp) =>
          resolve({ ...comp.default, name: "NVOCCE" })),
      meta: {
        title: "修改承运商档案",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/Custom",
      name: "CustomC",
      component: (resolve) =>
        require(["@/pages/Customers/Custom"], (comp) =>
          resolve({ ...comp.default, name: "CustomC" })),
      meta: {
        title: "客户档案",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomMOD/Create",
      name: "CustomCC",
      component: (resolve) =>
        require(["@/pages/Customers/CustomMOD/Create"], (comp) =>
          resolve({ ...comp.default, name: "CustomCC" })),
      meta: {
        title: "新建客户档案",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomMOD/Edit",
      name: "CustomMODEE",
      component: (resolve) =>
        require(["@/pages/Customers/CustomMOD/Edit"], (comp) =>
          resolve({ ...comp.default, name: "CustomMODEE" })),
      meta: {
        title: "修改客户档案",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/Consignee",
      name: "ConsigneeWWW",
      component: (resolve) =>
        require(["@/pages/Customers/Consignee"], (comp) =>
          resolve({ ...comp.default, name: "ConsigneeWWW" })),
      meta: {
        title: "收货人查询",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/Consignor",
      name: "Consignor",
      component: (resolve) =>
        require(["@/pages/Customers/Consignor"], (comp) =>
          resolve({ ...comp.default, name: "Consignor" })),
      meta: {
        title: "发货人查询",
        keepAlive: true,
      },
    },
    // 车辆管理
    {
      path: "/VMS/CarArchive",
      name: "CarArchive",
      component: (resolve) =>
        require(["@/pages/VMS/CarArchive"], (comp) =>
          resolve({ ...comp.default, name: "CarArchive" })),
      meta: {
        title: "车辆档案",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/DriverArchive",
      name: "DriverArchive",
      component: (resolve) =>
        require(["@/pages/VMS/DriverArchive"], (comp) =>
          resolve({ ...comp.default, name: "DriverArchive" })),
      meta: {
        title: "司机档案",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/GasArchive",
      name: "GasArchive",
      component: (resolve) =>
        require(["@/pages/VMS/GasArchive"], (comp) =>
          resolve({ ...comp.default, name: "GasArchive" })),
      meta: {
        title: "油卡档案",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/GasApply",
      name: "GasApply",
      component: (resolve) =>
        require(["@/pages/VMS/GasApply"], (comp) =>
          resolve({ ...comp.default, name: "GasApply" })),
      meta: {
        title: "油卡申领记录",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/VOCApply",
      name: "VOCApply",
      component: (resolve) =>
        require(["@/pages/VMS/VOCApply"], (comp) =>
          resolve({ ...comp.default, name: "VOCApply" })),
      meta: {
        title: "车辆成本",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/GasupRecord",
      name: "GasupRecord",
      component: (resolve) =>
        require(["@/pages/VMS/GasupRecord"], (comp) =>
          resolve({ ...comp.default, name: "GasupRecord" })),
      meta: {
        title: "加油记录",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/GascardEtc",
      name: "GascardEtc",
      component: (resolve) =>
        require(["@/pages/VMS/GascardEtc"], (comp) =>
          resolve({ ...comp.default, name: "GascardEtc" })),
      meta: {
        title: "油卡充值",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/GascardDaybook",
      name: "GascardDaybook",
      component: (resolve) =>
        require(["@/pages/VMS/GascardDaybook"], (comp) =>
          resolve({ ...comp.default, name: "GascardDaybook" })),
      meta: {
        title: "油卡流水账",
        keepAlive: true,
      },
    },
  ],
};
